module.exports = __webpack_public_path__ + "img/jenkins.fecc8217.png";